import { render, staticRenderFns } from "./StudentReport.vue?vue&type=template&id=b2926650"
import script from "./StudentReport.vue?vue&type=script&lang=js"
export * from "./StudentReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports